import { Link } from 'react-router-dom';

const quickLinks = [
  { label: '首页', to: '/' },
  { label: '电视剧', to: '/category/电视剧' },
  { label: '花絮资讯', to: '/category/花絮' },
  { label: '搜索', to: '/search' },
  { label: '关于我们', to: '/about' },
];

export default function Footer() {
  return (
    <footer className="mt-16 bg-primary-900 text-background-100">
      <div className="mx-auto w-full max-w-site px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3 md:gap-12">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-primary-950">
                <i className="ri-movie-2-line text-lg" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50">我妻子的一切</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-200">
              聚焦《我妻子的一切》及相关影视作品，提供最新剧集资讯、剧情介绍、角色资料与幕后花絮，
              陪你看懂每一段故事背后的情绪。
            </p>
          </div>

          <div className="md:ml-auto">
            <h3 className="font-heading text-base font-bold text-background-50">内容导航</h3>
            <ul className="mt-4 space-y-3 text-sm">
              {quickLinks.map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className="text-background-200 transition-colors hover:text-accent-400">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-background-50">联系我们</h3>
            <ul className="mt-4 space-y-3 text-sm text-background-200">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400" />
                contact@wife-of-mine.example.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-accent-400" />
                每日 09:00 - 22:00 更新剧集资讯
              </li>
            </ul>
            <div className="mt-5 flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-800 text-background-100 transition-colors hover:bg-accent-500 hover:text-primary-950">
                <i className="ri-weibo-line" />
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-800 text-background-100 transition-colors hover:bg-accent-500 hover:text-primary-950">
                <i className="ri-wechat-line" />
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-800 text-background-100 transition-colors hover:bg-accent-500 hover:text-primary-950">
                <i className="ri-video-line" />
              </span>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-800 pt-6 text-xs text-background-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 我妻子的一切 · 影视资讯内容站。本页面为演示内容，所涉剧集信息均为虚构。</p>
          <p>内容仅供影视爱好者交流参考，不提供任何播放与下载服务。</p>
        </div>
      </div>
    </footer>
  );
}